import {
  AtSign,
  Bell,
  CircleCheck,
  CircleX,
  RotateCcw,
  ClipboardList,
  FileSearch,
  FileUp,
  GitBranch,
  Megaphone,
  MessageSquare,
  Shield,
  StickyNote,
  TriangleAlert,
  type LucideIcon,
} from "lucide-react";

import type { NotificationCategory, NotificationKind } from "@recobra/schemas/notification";

const notificationCategoryStyle = (category: NotificationCategory): { className: string } => {
  switch (category) {
    case "mention":
      return {
        className: "bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300",
      };
    case "task":
      return {
        className: "bg-purple-100 text-purple-700 dark:bg-purple-950 dark:text-purple-300",
      };
    case "security":
      return {
        className: "bg-orange-100 text-orange-700 dark:bg-orange-950 dark:text-orange-300",
      };
    case "conversation":
      return {
        className: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
      };
    case "system":
      return { className: "bg-muted text-muted-foreground" };
    default:
      return { className: "bg-muted text-muted-foreground" };
  }
};

const notificationKindIcon = (kind: NotificationKind): LucideIcon => {
  switch (kind) {
    case "task.assigned":
      return ClipboardList;
    case "task.canceled":
      return CircleX;
    case "task.reopened":
      return RotateCcw;
    case "task.completed":
      return CircleCheck;
    case "task.sla_breach":
      return TriangleAlert;
    case "task.reminder":
      return Bell;
    case "note.added":
      return StickyNote;
    case "note.mention":
      return AtSign;
    case "case.step_changed":
      return GitBranch;
    case "message.received":
      return MessageSquare;
    case "document.classified":
      return FileSearch;
    case "document.uploaded":
      return FileUp;
    case "security.sign_in":
      return Shield;
    case "system.broadcast":
      return Megaphone;
    default:
      return Bell;
  }
};

export const notificationIcon = (item: {
  kind: NotificationKind;
  category: NotificationCategory;
}): { Icon: LucideIcon; className: string } => ({
  Icon: notificationKindIcon(item.kind),
  ...notificationCategoryStyle(item.category),
});
